import { MatchingFailProvider } from '@context/MatchingFail';
import MatchingFailView from '@pages/MatchingFail/MatchingFailView';

const MatchingFail = () => {
  return (
    <MatchingFailProvider>
      <MatchingFailView />
    </MatchingFailProvider>
  );
};

export default MatchingFail;
